import React from "react";
import { Route, Redirect } from "react-router-dom";
import { getAccessToken } from "../utility/utils";
// TODO: need to handle at platform level
const PublicRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) =>
        getAccessToken() ? <Redirect to="/" /> : <Component {...props} />
      }
    />
  );
};

export default PublicRoute;
